import React from "react";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Form from "react-bootstrap/Form";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../assets/img/vlogo.png";
import { HashLink } from "react-router-hash-link";

export default function Header({ link }) {
  const [activeLink, setActiveLink] = useState(link);
  const [scrolled, setScrolled] = useState(false);
  const [isLoggedIn, setIsLoggenIn] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setIsLoggenIn(true);
    } else {
      setIsLoggenIn(false);
    }
  }, []);
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  function handleLogOut() {
    Cookies.remove("token");
    Cookies.remove("userName");
    Cookies.remove("email");
    if (link === "home") {
      window.location.reload();
    } else {
      navigate("/");
    }
  }
  return (
    <>
      {["sm"].map((expand) => (
        <Navbar
          key={expand}
          expand={expand}
          className={scrolled ? "scrolled" : ""}
        >
          <Container fluid>
            <Navbar.Brand href="#">
              <img
                style={{ padding: "0px", margin: "0px" }}
                src={logo}
                alt="Logo"
                className="brandimage"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              style={{
                background: "#121212",
                color: "#fff",
                textDecoration: "none",
                zIndex: 10000000,
              }}
            >
              <Offcanvas.Header closeVariant="white" closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Menu
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Link
                    to="/"
                    className={
                      activeLink === "home"
                        ? "active navbar-link"
                        : "navbar-link"
                    }
                    onClick={() => onUpdateActiveLink("home")}
                  >
                    Home
                  </Link>

                  <Link
                    to="/tournament"
                    className={
                      activeLink === "tournament"
                        ? "active navbar-link"
                        : "navbar-link"
                    }
                    onClick={() => onUpdateActiveLink("tournament")}
                  >
                    Tournament
                  </Link>

                  <Link
                    to="/friendlyMatch"
                    className={
                      activeLink === "friendlyMatch"
                        ? "active navbar-link"
                        : "navbar-link"
                    }
                    onClick={() => onUpdateActiveLink("friendlyMatch")}
                  >
                    Friendly Match
                  </Link>
                  <HashLink
                    to="#footer"
                    className={
                      activeLink === "contact"
                        ? "active navbar-link"
                        : "navbar-link"
                    }
                    onClick={() => onUpdateActiveLink("contact")}
                  >
                    Contact
                  </HashLink>
                </Nav>
                <Form className="d-flex">
                  {!isLoggedIn && (
                    <Link className="nav-link " to="/login">
                      {" "}
                      <Button className="hbutton">Login</Button>{" "}
                    </Link>
                  )}
                  {isLoggedIn && (
                    <Button onClick={handleLogOut} className="hbutton">
                      Logout
                    </Button>
                  )}
                </Form>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}
